"use client";

import * as React from "react";

import { createSVGIcon } from "../util";

const VIEWBOX = "0 0 24 24";

/**
 * @trackcomponent
 * @donotsync shifts upwards (@quinlan.sokol)
 */
export const Minimize = createSVGIcon(
  <>
    <path d="M1 23.2863L9.57143 14.7148" stroke="currentColor"></path>
    <path d="M2.71436 14.7148H9.5715V21.572" stroke="currentColor"></path>
    <path d="M23.2858 1L14.7144 9.57143" stroke="currentColor"></path>
    <path d="M21.5715 9.57199H14.7144V2.71484" stroke="currentColor"></path>
  </>,
  "Minimize",
  (strictLocalize) => ({
    viewBox: VIEWBOX,
    titleAccess: strictLocalize({
      defaultMessage: "Minimize",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
